export const UNSUPPORTED_NETWORK = 'Unsupported network';
export const NO_SIGNER = 'Wallet not connected';
export const NO_PYTH_ID = 'No Pyth ID for this asset';
//# sourceMappingURL=errors.js.map